import { Component, OnInit } from '@angular/core';
import {ApiService} from '../services/api.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  model:any;

  constructor(
    public ApiServiceCall: ApiService,
  ) { 
    this.model = {};
  }

  ngOnInit(): void {
  }
  onSubmit() {
    var obj = {
      name:this.model.fullName, 
      mobileNo:this.model.mobileNo,
      email:this.model.email,
      TextMessage:this.model.msg
    }
    this.ApiServiceCall.contactSave(obj).subscribe((data) => {
     alert(data.responseMessage);
    });
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.model));
    this.model = {};
  }

}
